import { useForm } from 'react-hook-form'
import { useParamsList } from 'src/hooks/useParamsList.hook'
import { TermsListSpace } from 'src/types/api'
import { FormObjectType, JoinFormType, otpCertItemsForm } from 'src/types/react-hook-form'
import { NumReplace, formatShortPNumber } from 'src/service/utils/strReg'
import { certNumberPattern } from 'src/service/utils/strReg'
import usePcodeMatch from 'src/hooks/usePcodeMatch.hook'
import { createTermsAttribute } from './shared/createTermsAttribute'
import { otpCertDefaultValues, telecomConverter, termsDefaultValues } from './shared/termsConstants'
import { useTermsAgreement } from './shared/useTermsAgreement'
import { monitoredOpen } from 'src/service/utils/sentry/navigation'

export { telecomConverter } from './shared/termsConstants'

const useJoinForm = (termsQueryData?: TermsListSpace.Response) => {
  const { bill_letter } = usePcodeMatch()
  const { telecom, fixedTelecom } = useParamsList()
  const telecomValue = fixedTelecom || telecom
  const telecomName = telecomConverter[telecomValue as string]

  const termsData =
    (termsQueryData?.[telecomName] as TermsListSpace.AllTermsType & { Idx: number }) ||
    termsDefaultValues

  const methods = useForm<JoinFormType>({
    mode: 'onSubmit',
    defaultValues: { ...otpCertDefaultValues, ...termsDefaultValues },
  })

  const { setValue } = methods

  const { requiredTermsList, allTermsAgreeHandler, updateAllTermsAgree } = useTermsAgreement(
    termsData,
    methods,
  )

  const handleShowPopupOpen = (termsKey: string) => {
    const openurl = !!bill_letter
      ? `sendEventToApp:onClickedOutPage=${window.location.origin}/terms/${telecomValue}/${termsKey}`
      : `${window.location.origin}/terms/${telecomValue}/${termsKey}`

    const target = !!bill_letter ? '' : '_blank'
    monitoredOpen(openurl, 'handleShowPopupTerms', target, {
      windowFeatures: 'width=400,height=600,left=200,top=200',
    })
  }

  const termsAttribute = createTermsAttribute({
    termsData,
    telecomValue,
    updateAllTermsAgree,
    allTermsAgreeHandler,
    showTermsPopup: handleShowPopupOpen,
  })

  const otpCertAttribute: Record<keyof otpCertItemsForm, Partial<FormObjectType>> = {
    TranID: {
      tag: 'TranID',
      register_options: { required: true },
    },
    PNumber: {
      tag: 'PNumber',
      type: 'tel',
      register_options: {
        onChange: (event: { target: { value: string } }) => {
          setValue('PNumber', formatShortPNumber(event.target.value), {
            shouldValidate: true,
          })
        },
        pattern: { value: /([0-9]{4}) ([0-9]{4})$/, message: '' },
        minLength: { value: 9, message: '' },
        maxLength: { value: 9, message: '' },
        inputMode: 'numeric',
      },
    },
    ApprovalNumber: {
      tag: 'ApprovalNumber',
      type: 'tel',
      register_options: {
        required: false,
        onChange: (event: { target: { value: string } }) => {
          setValue('ApprovalNumber', NumReplace(event.target.value, 4), {
            shouldValidate: true,
          })
        },
        minLength: { value: 1, message: '인증번호를 입력해주세요.' },
        pattern: { value: certNumberPattern, message: '인증번호를 정확하게 입력하여 주십시오.' },
        inputMode: 'numeric',
      },
    },
  }

  return {
    methods,
    registerAttribute: { ...termsAttribute, ...otpCertAttribute },
    requiredTermsList,
    allTermsAgreeHandler,
    termsData,
  }
}

export default useJoinForm
